import type {
  VifGearsChart,
  VifGearsChartIndex,
  VifTestWindow,
  VifTestWindowCell,
} from '../types';

/**
 * Looks up a `testWindow` grid cell by row/col. The FLA-authored grid
 * addresses cells dynamically as `row{r}col{c}`, so this confines the single
 * cast needed to bridge that runtime naming convention to the statically
 * enumerated `VifTestWindow` members.
 */
export function cellAt(
  win: VifTestWindow,
  row: number,
  col: number,
): VifTestWindowCell {
  const key = `row${row}col${col}` as `row${0 | 1 | 2 | 3}col${0 | 1 | 2 | 3}`;
  return win[key];
}

/**
 * Looks up a gears-chart cell by its `a{n}`/`s{n}` prefix and index. Confines
 * the single cast needed to bridge the FLA-authored runtime naming
 * convention to the mapped-type `VifGearsChart` members.
 */
export function chartCell(
  chart: VifGearsChart,
  prefix: 'a' | 's',
  index: VifGearsChartIndex,
): createjs.MovieClip | undefined {
  const key: `a${VifGearsChartIndex}` | `s${VifGearsChartIndex}` =
    prefix === 'a' ? `a${index}` : `s${index}`;
  return chart[key];
}
